import React, {useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {LOOK_INTRO_STEPS, LOOK_OVERLAYS} from "../../look/core/constants";
import {setLookIntroStep, setLookOverlayOpened} from "../../../actions/lookFunctions";
import {MaterialPhotoPrintsIcon} from "../../common/svgIcons/materialIcons";
import LookIntroPopper from "../../look/lookNavigation/lookIntro/lookIntroPopper";
import {getCommonVisualizerType} from "../../../config";
import {setLookAiImageOpened} from "../aiActions";

const LookSideBarAIMobileButton = (props) => {

  const {intl, lookPageOpened, sidebarButtonClicked, popupCloseClick, disabled, setLookOverlayOpened, aiResults,
    introStep, setLookIntroStep, setLookAiImageOpened} = props;

  const anchorRef = useRef(null);
  const neededIntroStep = LOOK_INTRO_STEPS.aiStep;
  const introIsActive = introStep !== LOOK_INTRO_STEPS.welcome;

  const aiButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarMobileAi);
    if (introIsActive) {
      setLookIntroStep();
      return false;
    }
    if (lookPageOpened && popupCloseClick) {
      popupCloseClick();
    } else {
      setLookOverlayOpened(LOOK_OVERLAYS.aiPanel);
      const someResultExist = aiResults.some(res => res.resultImageUrl);
      if (someResultExist) {
        setLookAiImageOpened(true);
      }
    }
    sidebarButtonClicked();
  }

  const realDisabled = disabled;
  const visualizerType = getCommonVisualizerType();
  const title = intl.formatMessage({id:"look.intro.aiStep.tooltip"}, {visualizerType});

  return (
    <li className="look-sidebar__list-item ping-pilot-visualizer-button">
      <Tooltip title={title} placement="right">
        <IconButton aria-label={title}
                    ref={anchorRef}
                    disabled={realDisabled}
                    className={"look-icon look-sidebar__button color-primary"
                      + (introStep === neededIntroStep ? " look-sidebar__button--intro" : "")}
                    onClick={aiButtonClick}>
          {MaterialPhotoPrintsIcon}
        </IconButton>
      </Tooltip>
      <LookIntroPopper anchorRef={anchorRef}
                       currentStep={neededIntroStep}
                       visualizerType={visualizerType}
                       toolTipText={"look.intro.aiStep.tooltip"}/>
    </li>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  const {lookPageOpened, introStep} = store.lookState;
  const {aiResults} = store.aiState;

  return {
    lookPageOpened,
    visualizersLoadedLength: visualizersLoaded.length,
    introStep,
    aiResults,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookIntroStep,
  setLookAiImageOpened,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookSideBarAIMobileButton)
  )
)
